const UPLOAD_CONFIGS = {
  MIN_FILE: 1,
  MAX_FILE: 10,
  MAX_FILE_SIZE_IN_MB: 10,
  ACCEPT_FILE_TYPES: {
    "application/pdf": [".pdf"],
    "image/jpeg": [".jpeg", ".jpg"],
    "image/png": [".png"],
    "audio/mp4": [".m4a"],
    "video/quicktime": [".mov"],
    "audio/mpeg": [".mp3"],
    "video/mp4": [".mp4"],
    "video/webm": [".webm"],
  },
}

export { UPLOAD_CONFIGS }
